import "./DetailsViewCardComponent.scss";
import React from "react";

interface DetailsViewCardComponentProps {
    title?: string;
    className?: string;
    actions?: React.ReactNode;
}

const DetailsViewCardComponent = (props: React.PropsWithChildren<DetailsViewCardComponentProps>) => {
        const {title, className, children, actions} = props;

        return (
            <div className={`details-view-card-component ${className}`}>
                {(title) && <div className="details-view-card-header">
                    <div className="details-view-card-title">
                        {title}
                    </div>
                    {
                        actions && <div className="details-view-card-actions">
                            {actions}
                        </div>
                    }
                </div>}
                {
                    (React.Children.count(children)) > 0 && <div className="details-view-card-body">
                        {children}
                    </div>
                }
            </div>
        );

    }
;

export default DetailsViewCardComponent;